import { createAction, props } from "@ngrx/store";
import { Action } from "@ngrx/store"; // Action is an interface of type string

// ------ Assign ------
// ****** NOT IN USE YET *********
export const assign = createAction(
    "[Assign] Assign To Selected Students",
    props<{
        payload: any;
    }>()
);
export const assignFail = createAction(
    "[Assign] Assign To Selected Students Fail",
    props<{
        payload: any;
    }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const assignSuccess = createAction(
    "[Assign] Assign To Selected Students Success",
    props<{
        payload: any;
    }>()
);

// ------ Update Selected Students ------
export const updateSelectedStudents = createAction(
    "[Assign] Update Selected Students",
    props<{
        payload: any;
    }>()
);
export const updateSelectedStudentsFail = createAction(
    "[Assign] Update Selected Students Fail",
    props<{
        payload: any;
    }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const updateSelectedStudentsSuccess = createAction(
    "[Assign] Update Selected Students Success",
    props<{
        payload: any;
    }>()
);
